/*
 * The handful of view helpers that belong to no one area: a download link, a
 * dashboard reload, the two row-removal helpers the grid editors use, and the
 * login/access-window toggle shared by Person Policy and Resource Policy.
 *
 * These were the last names on the `Mcp.Admin.*` compat facade (Phase 3.4).
 * They are registered under `Shared` rather than a brand namespace, so the
 * markup names what the handler is instead of which era it came from.
 */
import { download, one } from '../core/dom';
import { reloadDashboards } from '../core/ajax';
import { toggleTimeWindow } from '../core/forms';

/**
 * Hide a row that is being deleted in a grid editor and set its companion
 * `Deleted` hidden field, so the POST of the whole collection carries the
 * removal. The row stays in the form -- an index gap would re-key every row
 * after it against the model binder.
 */
function rowSoftDelete(rowSelector: string, deletedFieldSelector: string): void {
    for (const row of document.querySelectorAll<HTMLElement>(rowSelector)) row.style.display = 'none';
    const flag = one(deletedFieldSelector) as HTMLInputElement | null;
    if (flag) flag.value = 'true';
}

/** Hide the "new row" scratch row of a grid editor without touching the model. */
function hideElement(selector: string): void {
    for (const node of document.querySelectorAll<HTMLElement>(selector)) node.style.display = 'none';
}

export const Shared = {
    DownloadUrl: download,
    ReloadDashboards: reloadDashboards,
    RowSoftDelete: rowSoftDelete,
    HideElement: hideElement,
    ToggleTimeWindow: toggleTimeWindow,
};
